<template>
  <div class="container">
    <div class="row justify-content-between mt-3">
      <div class="col-md-6 mt-3 pr-5"> <!-- left -->

        <UserData ref="userData" @accept="accept()" @nameForCardInput="nameForCardInput" />

        <UserPassport ref="userPassport" @accept="accept()" />

        <UserContact ref="userContact" @accept="accept()" />

        <DocumentsUpload />
      </div>

      <div class="col-md-6 mt-3"> <!-- right -->
        <PhotoSection ref="fotoSection" @uploaded="photoUploadedHandler"/>
        <MembershipRequest /> <!-- строка состояние оплаты -->

        <div class="row mt-5" v-if="!lifeMember"> <!-- memberbership payment -->
          <MembershipPayment :memberStatus="memberStatus" :accept="acceptPay" />
        </div>

        <template v-if="showMemberCard"> <!-- card data -->
          <div class="row mt-5"><h3>Членская карта АОПА</h3></div>

          <div class="card-head justify-content-around align-items-center row">
            <div class="col-6 card-logo">
              <img src="img/logo.png">
            </div>
            <div class="align-self-center col-6 head-text">
              <div class="txt">Aircraft owners</div>
              <div class="txt">&amp; Pilots Association</div>
              <div class="txt">Межрегиональная общественная</div>
              <div class="txt">организация пилотов и граждан</div>
              <div class="txt">владельцев воздушных судов</div>
            </div>
          </div>
          <div class="row card-text-row justify-content-center">
            <div class="col-10 text-center mid">CREW MEMBER CERTIFICATE</div>
            <div class="col-2 rus-flag"><img src="img/rus-flag.png"></div>
          </div>
          <div class="row card-body">
            <div class="col-4 p-0 pl-1 pl-sm-3"> <!-- card-foto -->
              <img :src="userFoto || '/img/no-photo.png'" alt="фото" class="img-thumbnail rounded card-foto" ref="userFotoCard" />
            </div>
            <div class="col-4 fio text-uppercase mt-1">
              <b>{{ (currentNameForCard !== '') ? currentNameForCard : nameForCard }}</b>
              <br>
              <small>ID-№ {{ cardNumber }}</small>
            </div>
            <div class="col-4 pl-0">
              <div class="row mt-1">
                <div class="col-5">
                  <div class="row"><div class="card-date-text col-12">Member</div></div>
                  <div class="row"><div class="card-date-text col-12">since:</div></div>
                </div>
                <div class="col-7">
                  <small class="card-date-text">{{ engDateCard(beginDate) }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col-5 text-right">
                  <small class="card-date-text">Expires:</small>
                </div>
                <div class="col-7">
                  <small class="card-date-text">{{ lifeMember ? 'No expiration date' : engDateCard(endDate) }}</small>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!--
        <div class="row mt-5">
          <h4> Зачем нужно стать членом АОПА-Россия </h4>
          <small>
            <strong>Главная цель</strong> – поддержка общественной организации, защищающей Ваши интересы. АОПА-Россия занимается активным лоббированием интересов малой авиации и либерализацией воздушного законодательства в нашей с Вами стране. На спонсорские и членские взносы АОПА-Россия оказывает юридическую помощь членам и участникам организации.<br>
            Дополнительные преимущества, которые Вы лично получите, как обладатель членской карты АОПА-Россия можно коротко описать несколькими пунктами:<br>
            1.  Членская карта АОПА-Россия является идентификационной картой членов экипажей воздушных судов для служб авиационной безопасности аэропортов как в России так и за рубежом.<br>
            2.  Скидки для членов АОПА-Россия предоставляют большое количество аэродромов и аэропортов, которые не берут плату за взлёт-посадку с членов АОПА, ряд компаний предоставляют скидки на парковку, обслуживание и ГСМ. Учебные центры предоставляют скидку на обучение.<br>
            3.  Многие гостиницы, компании, предоставляющие автомобили в аренду и другие сервисные организации предоставляют существенные скидки по предъявлению карты АОПА-Россия.<br>
            4.  Большое количество партнёрских коммерческих компаний АОПА-Россия, предоставят Вам скидки на свою продукцию и обслуживание.<br>
            Полный перечень преимуществ представлен на сайте АОПА-Россия <a href="http://aopa.ru/">www.aopa.ru</a><br>
          </small>
        </div>
        -->

        <div class="row mt-5" v-if="memberStatus === 'other_member'">
          <h4>Для вступления в члены АОПА-Россия и получения членской ID-карты необходимо:</h4>
              <ol>
                  <li>Заполнить анкетные данные, включая фото</li>
                  <li>Оплатить членский взнос</li>
                  <li>Отправить распечатанную анкету на <a href="https://aopa.ru/index.php?id=54">почтовый адрес АОПА-Россия</a></li>
                  <li>Получить членскую ID-карту (лично или по почте)</li>
              </ol>
        </div>
      </div>
    </div>

  <PaymentModalEventWrapper />
  </div>
</template>

<script>
import UserData from '@/components/UserData.vue'
import UserPassport from '@/components/UserPassport.vue'
import DocumentsUpload from '@/components/DocumentsUpload.vue'
import UserContact from '@/components/UserContact.vue'
import MembershipPayment from '@/components/MembershipPayment.vue'
import MembershipRequest from '@/components/MembershipRequest'
import PhotoSection from '@/components/PhotoSection'
import PaymentModalEventWrapper from '@/components/PaymentModalEventWrapper.vue';

export default {
  components: {
    //Input,
    MembershipPayment,
    UserData,
    UserPassport,
    UserContact,
    MembershipRequest,
    PhotoSection,
    DocumentsUpload,
    PaymentModalEventWrapper,
  },
  data() {
    return {
      userFoto: this.$store.getters.getUserData.memberInfo?.photo,
      photoUploaded: !!this.$store.getters.getUserData.memberInfo?.photo,
      memberStatus: this.$store.getters.getUserData.memberInfo?.status,      // статус членства
      cardNumber: this.$store.getters.getUserData.memberInfo?.cardNumber,
      beginDate: this.$store.getters.getUserData.memberInfo?.membership_begin_date,
      endDate: this.$store.getters.getUserData.memberInfo?.membership_end_date,
      currentNameForCard: '',
      acceptPay: false,
      image: [ 'jpeg', 'png', 'jpg' ],
      engMonth: [ 'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC' ],
      lifeMember: false,
      photoWidth: null,
      photoHeight: null,
      //membershipRequest: this.$store.getters.getUserData.memberInfo?.membershipRequest,
    }
  },
  mounted() {
    const img = new Image()

    img.src = this.$store.getters.getUserData.memberInfo?.photo
    img.onerror = () => {
      // Здесь можно обработать ошибку загрузки фото с сервера
      this.userFoto = ''
    };

    if (this.$route.meta.current_user) this.$store.dispatch('loginWithCookie', this.$route.meta.current_user)
    .then(() => {
      this.accept()
    })

    // проверяем пожизненное членство
    // const ed = this.$store.getters.getUserData.memberInfo?.membership_end_date
    // if (ed) {
    //   const d = ed.split('-')
    //   const now = new Date()

    //   this.lifeMember = d[0] - now.getFullYear() > 10
    // }
    this.lifeMember = parseInt(this.cardNumber) < 1001001

    //console.log(this.$store.getters.getUserData) //!
    this.accept()
  },
  computed: {
    nameForCard() {
      return this.$store.getters.getUserData.memberInfo?.nameForCard
    },
    showMemberCard() {
      return (this.memberStatus !== 'other_member') && this.beginDate;
    }
  },
  methods: {
    accept() {
      if (this.$refs.userData?.state !== 1 || this.$refs.userPassport?.state !== 1 || this.$refs.userContact?.state !== 1 || !this.photoUploaded) {
        this.acceptPay = false
        return false
      }

      if (this.$refs.fotoSection.isErrorImg() && (this.memberStatus !== 'was_member' && this.memberStatus !== 'active_member')) {
        this.acceptPay = false
        return false
      }

      this.acceptPay = true
      return true
    },
    engDateCard(date) {
      const d = new Date(date)
      if (d.getFullYear() === 1970) return ''
      return `${ this.engMonth[d.getMonth()] }.${ d.getFullYear() }`
    },
    nameForCardInput(value) {
      this.currentNameForCard = value
    },
    photoUploadedHandler() {
      this.photoUploaded = true;
      this.accept();
    }
  }
 }
</script>

<style scoped>
  .card-head {
    background-color: rgb(4, 174, 216);
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    height: 60px;
  }
  .card-logo > img {
    width: 100px;
    height: 40px;
    margin: 0 auto;
    display: flex;
    align-self: center;
  }
  .txt {
    color: white;
    font-size: 6px;
  }
  .card-text-row {
    background-color: navy;
    height: 25px;
    color: white;
  }
  .rus-flag > img {
    width: 20px;
    height: 15px;
  }
  .card-body {
    height: 150px;
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px;
    border: 1px solid grey;
    padding: 0;
  }
  .card-foto {
    width: 100px;
    height: 133px;
    margin-top: 5px;
  }
  .fio {
    overflow: hidden;
  }
  .fio > small {
    font-size: 12px;
  }
  .fio > b {
    color: navy;
    font-size: 13px;
  }
  .card-date-text {
    font-size: 10px;
    color: navy;
    font-weight: bold;
  }

  @media screen and (min-width: 992px) {
    .card-head {
      height: 80px;
    }
    .card-logo > img {
      width: 140px;
      height: 50px;
    }
    .txt {
      font-size: 9px;
    }
    .card-body {
      height: 160px;
    }
    .card-foto {
      width: 110px;
      height: 146px;
    }
    .fio > small {
      font-size: 14px;
    }
    .fio > b {
      font-size: 18px;
    }
    .card-date-text {
      font-size: 12px;
    }
  }
  @media screen and (min-width: 1440px) {
    .card-head {
      height: 100px;
    }
    .card-logo > img {
      width: 180px;
      height: 60px;
    }
    .txt {
      font-size: 12px;
    }
    .card-text-row {
      height: 30px;
    }
    .mid {
      font-size: 20px;
    }
    .rus-flag > img {
      width: 30px;
      height: 20px;
    }
    .card-body {
      height: 220px;
    }
    .card-foto {
      width: 150px;
      height: 200px;
    }
    .fio > small {
      font-size: 16px;
    }
    .fio > b {
      font-size: 20px;
    }
    .card-date-text {
      font-size: 14px;
    }
  }
</style>
